import { useState } from 'react';

const DREAM_REVIEWS = [
  {
    id: 1,
    name: '이찬호',
    age: 42,
    occupation: '자영업',
    location: '경기도 수원',
    avatar: 'https://public.readdy.ai/ai/img_res/9c476ab93b0d0f9152b4903722cf99e4.jpg',
    dreamType: '돼지꿈',
    dreamIcon: '🐷',
    dreamEmoji: '🎰',
    title: '황금 돼지가 나온 다음 날, 로또 3등 당첨',
    story: '꿈에서 거대한 황금 돼지가 저한테 달려와서 황금 동전을 입에서 쏟아냈어요. 너무 생생해서 잠에서 깨자마자 꿈해몽 AI에 물어봤더니 "재물이 예상치 못한 방향에서 유입될 강력한 길몽"이라고 분석해줬습니다. 그날 충동적으로 로또를 샀는데 3등이 됐어요. 10만원 수익은 아니지만... 꿈해몽 결과가 맞아떨어진 것 자체가 신기했습니다.',
    result: '로또 3등 당첨 (10만원)',
    verified: true,
    luckType: '길몽',
    date: '2025년 11월',
    rating: 5,
  },
  {
    id: 2,
    name: '박소현',
    age: 34,
    occupation: '직장인',
    location: '서울 마포',
    avatar: 'https://readdy.ai/api/search-image?query=korean%20woman%20mid%2030s%20bright%20cheerful%20smile%20medium%20length%20black%20hair%20wearing%20navy%20blouse%20natural%20makeup%20soft%20warm%20indoor%20background%20portrait%20photography&width=200&height=200&seq=dreview-2&orientation=squarish',
    dreamType: '용꿈',
    dreamIcon: '🐉',
    dreamEmoji: '💼',
    title: '용이 나를 등에 태운 꿈 → 두 달 뒤 승진 확정',
    story: '꿈에서 황금 용이 저를 등에 태우고 하늘 높이 날아올랐어요. 올라가면서 아래 도시가 내려다보이는 느낌이 너무 생생했어요. 꿈해몽 결과에서 "용 꿈은 한국 전통 최고 길몽으로 출세와 도약의 전조"라고 나왔는데, 실제로 그 달에 인사고과가 최우수로 나오고 두 달 뒤에 팀장 승진이 확정됐습니다. 주변에서 제가 꿈 이야기를 하면 다들 신기해했어요.',
    result: '팀장 승진 확정',
    verified: true,
    luckType: '길몽',
    date: '2026년 1월',
    rating: 5,
  },
  {
    id: 3,
    name: '김도현',
    age: 28,
    occupation: '대학원생',
    location: '부산 해운대',
    avatar: 'https://readdy.ai/api/search-image?query=young%20korean%20man%20late%2020s%20studious%20focused%20look%20slight%20smile%20wearing%20simple%20grey%20sweatshirt%20natural%20dark%20background%20minimal%20portrait%20photography&width=200&height=200&seq=dreview-3&orientation=squarish',
    dreamType: '이빨 빠지는 꿈',
    dreamIcon: '😬',
    dreamEmoji: '⚠️',
    title: '흉몽 경고 덕분에 교통사고 위기 피함',
    story: '이빨이 줄줄이 빠지는 꿈을 연속 3일 꿨어요. 꿈해몽 AI에서 "예상치 못한 손실이나 건강 이상, 교통 관련 주의가 필요한 흉몽"이라는 분석이 나왔습니다. 솔직히 처음엔 무시했는데 3일 연속이니까 불안해서 평소에 속도 내던 도로에서 천천히 갔는데, 앞 차가 갑자기 급브레이크를 밟아서 살짝 박을 뻔했어요. 경고를 무시하지 않은 게 다행이었습니다.',
    result: '사고 예방 · 건강 검진으로 조기 발견',
    verified: false,
    luckType: '흉몽',
    date: '2025년 10월',
    rating: 5,
  },
  {
    id: 4,
    name: '정유리',
    age: 36,
    occupation: '프리랜서 작가',
    location: '서울 성수동',
    avatar: 'https://readdy.ai/api/search-image?query=korean%20woman%20mid%2030s%20creative%20artistic%20vibe%20warm%20gentle%20smile%20wearing%20light%20beige%20cardigan%20hair%20up%20in%20bun%20soft%20natural%20indoor%20light%20background%20portrait&width=200&height=200&seq=dreview-4&orientation=squarish',
    dreamType: '하늘 나는 꿈',
    dreamIcon: '🦋',
    dreamEmoji: '📚',
    title: '하늘 나는 꿈 해몽 후 첫 책 계약 성사',
    story: '발이 땅에서 떨어져서 구름 위를 나는 꿈이었어요. 전혀 무섭지 않고 너무 자유롭고 상쾌했어요. 꿈해몽 AI가 "자유와 성공에 대한 강한 욕망이 현실로 발현되는 전조"라고 분석해줬고, "무대와 공공 영역에서 당신의 목소리가 울릴 것"이라는 부분이 마음에 걸렸어요. 그로부터 3주 뒤에 출판사에서 원고 제안이 들어왔고 계약을 맺었습니다. 꿈이 글쓰기 의지를 불태운 계기이기도 했어요.',
    result: '첫 단독 책 출판 계약',
    verified: true,
    luckType: '길몽',
    date: '2026년 2월',
    rating: 5,
  },
  {
    id: 5,
    name: '오태준',
    age: 45,
    occupation: '중소기업 대표',
    location: '경남 창원',
    avatar: 'https://readdy.ai/api/search-image?query=korean%20businessman%20mid%2040s%20professional%20confident%20look%20slightly%20grey%20temples%20wearing%20white%20shirt%20no%20tie%20relaxed%20pose%20simple%20background%20portrait%20photography&width=200&height=200&seq=dreview-5&orientation=squarish',
    dreamType: '물 꿈',
    dreamIcon: '🌊',
    dreamEmoji: '📈',
    title: '맑은 강물 꿈 후 계약 수주 역대 최고',
    story: '넓고 맑은 강물이 유유히 흐르는 꿈이었어요. 그 강에 제가 발을 담그고 있는데 너무 시원하고 평화로웠어요. 꿈해몽 결과에서 "맑은 물은 사업 흐름이 막힘없이 이어질 것을 의미하며, 재물운이 상승하는 길몽"이라고 나왔습니다. 그 주에 3개월 동안 협상해오던 대기업 납품 계약이 갑자기 성사됐어요. 회사 창립 이래 최대 계약입니다. 꿈 기록을 계속 해왔는데, 맑은 물 꿈은 항상 좋은 일이 생겼어요.',
    result: '회사 창립 이래 최대 계약 수주',
    verified: true,
    luckType: '길몽',
    date: '2025년 9월',
    rating: 5,
  },
  {
    id: 6,
    name: '최지민',
    age: 26,
    occupation: '취준생',
    location: '대전',
    avatar: 'https://readdy.ai/api/search-image?query=young%20korean%20woman%20mid%2020s%20hopeful%20energetic%20expression%20short%20bob%20haircut%20wearing%20sky%20blue%20hoodie%20fresh%20youthful%20look%20soft%20background%20portrait%20photography&width=200&height=200&seq=dreview-6&orientation=squarish',
    dreamType: '태몽',
    dreamIcon: '✨',
    dreamEmoji: '🎉',
    title: '합격 태몽 해석 그대로 공무원 최종 합격',
    story: '꿈에서 해가 제 배 속으로 들어오는 느낌이 있었는데 뭔가 다른 꿈이었어요. 꿈해몽 AI에 입력하니까 "태몽과 유사한 구조로, 큰 기운이 당신 안에 들어오는 것은 중요한 성취나 새로운 시작의 전조"라는 분석이 나왔습니다. 당시 공무원 시험 3차 면접을 앞두고 있었는데, 이 분석 보고 자신감이 생겼어요. 결국 최종 합격했고, 꿈이 준 확신이 면접에서도 긍정적으로 작용한 것 같아요.',
    result: '공무원 시험 최종 합격',
    verified: false,
    luckType: '길몽',
    date: '2026년 3월',
    rating: 5,
  },
];

const LUCK_BADGE: Record<string, string> = {
  길몽: 'text-amber-400 bg-amber-500/10 border-amber-500/30',
  흉몽: 'text-red-400 bg-red-500/10 border-red-500/30',
  보통: 'text-purple-300 bg-purple-500/10 border-purple-500/30',
};

export default function DreamReviewSection() {
  const [expandedId, setExpandedId] = useState<number | null>(null);

  return (
    <section className="relative py-16 sm:py-20 px-4 sm:px-6">
      {/* Background */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute inset-0 bg-gradient-to-b from-transparent via-indigo-950/20 to-transparent"></div>
      </div>

      <div className="relative max-w-7xl mx-auto">
        {/* Header */}
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-primary-gold/10 border border-primary-gold/30 mb-4">
            <i className="ri-moon-foggy-fill text-primary-gold text-sm"></i>
            <span className="text-primary-gold text-xs font-semibold tracking-widest uppercase">꿈해몽 실제 체험담</span>
          </div>
          <h2 className="text-3xl sm:text-4xl font-black text-white mb-3 leading-tight"
            style={{ fontFamily: '"Noto Serif KR", serif' }}>
            꿈이 <span className="text-transparent bg-clip-text bg-gradient-to-r from-primary-gold via-amber-300 to-primary-gold">현실이 됐습니다</span>
          </h2>
          <p className="text-purple-300/70 text-base max-w-xl mx-auto">
            꿈 해몽 후 실제로 이어진 사용자들의 생생한 체험담을 소개합니다
          </p>

          {/* Stats */}
          <div className="flex flex-wrap items-center justify-center gap-6 sm:gap-10 mt-8">
            {[
              { icon: 'ri-star-fill', value: '4.9', label: '평균 별점' },
              { icon: 'ri-user-heart-line', value: '12,400+', label: '꿈 해몽 완료' },
              { icon: 'ri-check-double-line', value: '87%', label: '길흉 적중률' },
            ].map((s) => (
              <div key={s.label} className="text-center">
                <div className="w-8 h-8 flex items-center justify-center mx-auto mb-1">
                  <i className={`${s.icon} text-primary-gold text-lg`}></i>
                </div>
                <p className="text-white font-black text-xl">{s.value}</p>
                <p className="text-purple-400/60 text-xs">{s.label}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Reviews grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {DREAM_REVIEWS.map((review) => {
            const isExpanded = expandedId === review.id;
            const previewLength = 120;
            const isLong = review.story.length > previewLength;

            return (
              <div
                key={review.id}
                className="group p-5 rounded-2xl bg-gradient-to-br from-primary-dark/80 via-mystic-dark/70 to-primary-dark/80 border border-white/8 hover:border-primary-gold/30 transition-all duration-300"
              >
                {/* Top: avatar + info */}
                <div className="flex items-start gap-3 mb-4">
                  <div className="w-11 h-11 rounded-xl overflow-hidden flex-shrink-0 border border-white/10">
                    <img src={review.avatar} alt={review.name} className="w-full h-full object-cover object-top" />
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center gap-2 flex-wrap">
                      <p className="text-white text-sm font-bold">{review.name}</p>
                      <span className="text-purple-400/50 text-xs">{review.age}세 · {review.occupation}</span>
                    </div>
                    <div className="flex items-center gap-2 mt-0.5">
                      <span className={`text-[10px] font-bold px-2 py-0.5 rounded-full border ${LUCK_BADGE[review.luckType]}`}>
                        {review.dreamIcon} {review.dreamType}
                      </span>
                      {review.verified && (
                        <span className="flex items-center gap-0.5 text-[10px] text-emerald-400">
                          <i className="ri-verified-badge-fill text-[10px]"></i>
                          인증
                        </span>
                      )}
                    </div>
                  </div>
                  <span className="text-primary-gold text-lg flex-shrink-0">{review.dreamEmoji}</span>
                </div>

                {/* Title */}
                <h4 className="text-white text-sm font-bold mb-2 leading-snug">{review.title}</h4>

                {/* Story */}
                <p className="text-purple-300/70 text-xs leading-relaxed mb-3">
                  {isExpanded || !isLong ? review.story : review.story.slice(0, previewLength) + '...'}
                </p>
                {isLong && (
                  <button
                    onClick={() => setExpandedId(isExpanded ? null : review.id)}
                    className="text-primary-gold/70 text-xs hover:text-primary-gold transition-colors cursor-pointer mb-3 whitespace-nowrap"
                  >
                    {isExpanded ? '접기 ▲' : '더 보기 ▼'}
                  </button>
                )}

                {/* Result badge */}
                <div className="flex items-center gap-2 p-2.5 rounded-xl bg-primary-gold/8 border border-primary-gold/20">
                  <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                    <i className="ri-trophy-fill text-primary-gold text-xs"></i>
                  </div>
                  <p className="text-primary-gold text-xs font-semibold">{review.result}</p>
                </div>

                {/* Footer */}
                <div className="flex items-center justify-between mt-3">
                  <div className="flex gap-0.5">
                    {Array.from({ length: review.rating }).map((_, i) => (
                      <div key={i} className="w-3 h-3 flex items-center justify-center">
                        <i className="ri-star-fill text-primary-gold text-[10px]"></i>
                      </div>
                    ))}
                  </div>
                  <span className="text-purple-500/50 text-[10px]">{review.date} · {review.location}</span>
                </div>
              </div>
            );
          })}
        </div>

        {/* CTA */}
        <div className="text-center mt-10">
          <a
            href="/dream"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-2xl bg-gradient-to-r from-amber-400 via-yellow-500 to-amber-600 text-black font-bold text-sm hover:shadow-lg hover:shadow-amber-500/30 hover:scale-105 transition-all duration-300 whitespace-nowrap"
          >
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-moon-foggy-fill text-sm"></i>
            </div>
            <span>내 꿈 해몽하기</span>
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line text-sm"></i>
            </div>
          </a>
        </div>
      </div>
    </section>
  );
}
